
export const DATA_IDS = {
  ACTIVITY_MODAL_FORM: 'ActivityModalForm',
  ACTIVITY_MODAL_CANCEL_BUTTON: 'ActivityModalFormCancelButton',
  ACTIVITY_MODAL_SAVE_BUTTON: 'ActivityModalFormSaveButton',
  ACTIVITY_MODAL_SAVE_AND_CLOSE_BUTTON: 'ActivityModalFormSaveAndCloseButton',
}